import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { BootstrapDataContext } from '../../contexts'
import {
  CRUISE_PRODUCT_TYPE,
  FLIGHT_PRODUCT_TYPE,
  HOTEL_PRODUCT_TYPE,
  RENTAL_CAR_PRODUCT_TYPE,
  VACATION_PACKAGE_PRODUCT_TYPE
} from '../../constants/Constants'
import Header from '../header'
import ConditionalRender from '../../experiments/ConditionalRender'

const HEADERS = {
  [HOTEL_PRODUCT_TYPE]: {
    headingKey: 'B4960A5A2A',
    subheadKey: 'A7C8BAF8A8',
    heading: 'Save more on your next hotel',
    subhead: 'Thousands of deals made every day'
  },
  [FLIGHT_PRODUCT_TYPE]: {
    headingKey: 'HOMEPAGE.FLIGHTS.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.FLIGHTS.TAB.SUBHEADLINE',
    heading: 'Save more on your next flight',
    subhead: 'Thousands of deals made every day'
  },
  [RENTAL_CAR_PRODUCT_TYPE]: {
    headingKey: 'HOMEPAGE.RENTALCARS.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.RC.TAB.SUBHEADLINE',
    heading: 'Save more on your next rental car',
    subhead: 'Thousands of deals made every day'
  },
  [VACATION_PACKAGE_PRODUCT_TYPE]: {
    headingKey: 'HOMEPAGE.PACKAGES.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.VP.TAB.SUBHEADLINE',
    heading: 'Save up to $625 on your hotel and flight',
    subhead: 'Book together for our best deals'
  },
  [CRUISE_PRODUCT_TYPE]: {
    headingKey: 'HOMEPAGE.CRUISES.TAB.HEADLINE',
    subheadKey: 'HOMEPAGE.CRUISES.TAB.SUBHEADLINE',
    heading: 'Save more on your next cruise',
    subhead: 'Thousands of deals made every day'
  }
}

function TabHeader ({ currentTab }) {
  const {
    pclnData = {},
    signInStatus = {}
  } = useContext(BootstrapDataContext)

  const isSignedIn = signInStatus.signedIn || signInStatus.passiveSignIn
  const isNamePresent = pclnData.firstName
  const isVIP = isSignedIn && currentTab === 'hotels'
  const {
    headingKey,
    heading,
    subheadKey,
    subhead
  } = HEADERS[currentTab]

  const headingVIPKey = isNamePresent ? 'CBF880BFCA' : '904AD09CBE'
  const headline = isVIP ? headingVIPKey : headingKey
  let subheadline = isVIP ? '37BBA39836' : subheadKey

  return (
    <Header p={3}>
      <Header.Heading name={headline} fallback={heading} type='primary' />
      <ConditionalRender experimentCode='HP_LP_SUBHEADINGS' variantValue='NO_SUBHEADINGS'> // TODO: HP_LP_SUBHEADINGS clean-up
        <ConditionalRender.Original>
          <Header.Heading
            name={subheadline}
            fallback={subhead}
            type='secondary'
          />
        </ConditionalRender.Original>
      </ConditionalRender>
    </Header>
  )
}

TabHeader.propTypes = {
  currentTab: PropTypes.string.isRequired
}

export default TabHeader
